import { useList } from '../../../api/react-query';

export function useListLetterType({ params = {} }) {
  const { data, isLoading, refetch, isFetching, isRefetching } = useList(
    'lookups/employees/letter-types',
    { ...params },
  );

  return {
    data: data?.data?.data,
    count: data?.data?.total,
    isLoading: isLoading || isFetching || isRefetching,
    refetch,
  };
}
